__turbopack_context__.v({
  "listOpen": "TableOfContents-module__53Nwva__listOpen",
  "mobileToggle": "TableOfContents-module__53Nwva__mobileToggle",
});
